import {
  faCopy,
  faComment,
  faMoneyBillAlt,
  faTrashAlt,
  faArrowAltCircleDown,
  faBookmark,
  faImage,
  faCommentAlt,
  faStickyNote,
  faFileVideo,
  faAddressCard,
  faUserCircle,
  faQuestionCircle,
  faLaughBeam,
  faSmile,
  faMeh,
  faTimesCircle,
  faFilePowerpoint,
  faFileAudio,
} from '@fortawesome/free-regular-svg-icons';

import createFaIcon from './createFaIcon';

export const CommentIcon = createFaIcon(faComment);
export const CommentAltIcon = createFaIcon(faCommentAlt);
export const CopyIcon = createFaIcon(faCopy);
export const MoneyBillAltIcon = createFaIcon(faMoneyBillAlt);
export const TrashAltIcon = createFaIcon(faTrashAlt);
export const ArrowAltCircleDownIcon = createFaIcon(faArrowAltCircleDown);
export const BookmarkIcon = createFaIcon(faBookmark);
export const ImageIcon = createFaIcon(faImage);
export const StickyNoteIcon = createFaIcon(faStickyNote);
export const FileVideoIcon = createFaIcon(faFileVideo);
export const AddressCardIcon = createFaIcon(faAddressCard);
export const UserCircleIcon = createFaIcon(faUserCircle);
export const QuestionCircleIcon = createFaIcon(faQuestionCircle);
export const LaughBeamIcon = createFaIcon(faLaughBeam);
export const SmileIcon = createFaIcon(faSmile);
export const MehIcon = createFaIcon(faMeh);
export const TimesCircleIcon = createFaIcon(faTimesCircle);
export const FilePowerpointIcon = createFaIcon(faFilePowerpoint);
export const FileAudioIcon = createFaIcon(faFileAudio);
